import { render, staticRenderFns } from "./Address.vue?vue&type=template&id=11e4051b&scoped=true"
import script from "./Address.vue?vue&type=script&lang=js"
export * from "./Address.vue?vue&type=script&lang=js"
import style0 from "./Address.vue?vue&type=style&index=0&id=11e4051b&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11e4051b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3029718028/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11e4051b')) {
      api.createRecord('11e4051b', component.options)
    } else {
      api.reload('11e4051b', component.options)
    }
    module.hot.accept("./Address.vue?vue&type=template&id=11e4051b&scoped=true", function () {
      api.rerender('11e4051b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/profile/components/Address.vue"
export default component.exports